import React, { Component } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import Footer from "../partials/Footer";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import LiveContest from "../partials/contest/LiveContest";
import UpcomingContest from "../partials/contest/UpcomingContest";
import PastContest from "../partials/contest/PastContest";
import MyContest from "../partials/contest/MyContest";
import PaymentHistory from "../partials/contest/PaymentHistory";
import CommunityContest from "../partials/contest/CommunityContest";
import socketIOClient from "socket.io-client";
import { toast, Toaster } from "react-hot-toast";
import * as myConstList from "../../BaseUrl";
const jwtToken = localStorage.getItem("jwtToken");
const configToken = {
headers: {
Authorization: "Bearer " + `${localStorage.getItem("jwtToken")}`,
},
};
const toastStyles = {
style: {
borderRadius: "10px",
background: "#fff",
color: "#000",
},
};
const baseUrl = myConstList.baseUrl;
const callBackBaseUrl = myConstList.callBackBaseUrl;
class CommunityContestPage extends Component {
constructor(props) {
super(props);
this.columns = [
{
key: "_id",
text: "Id",
className: "id",
align: "left",
sortable: true,
cell: (row, index) => index + 1,
},
{
key: "Name",
text: "name",
className: "Name",
align: "left",
sortable: true,
},
{
key: "trades",
text: "Trades",
className: "trades",
align: "left",
sortable: true,
},
{
key: "profit",
text: "Profit Generated %",
className: "profit",
align: "left",
sortable: true,
},
];
this.config = {
page_size: 10,
length_menu: [10, 20, 50],
filename: "Users",
no_data_text: "No user found!",
button: {
excel: true,
print: true,
csv: true,
},
language: {
length_menu: "Show _MENU_ result per page",
filter: "Filter in records...",
info: "Showing _START_ to _END_ of _TOTAL_ records",
pagination: {
first: "First",
previous: "Previous",
next: "Next",
last: "Last",
},
},
show_length_menu: true,
show_filter: true,
show_pagination: true,
show_info: true,
};
this.state = {
records: [],
livePairData: [],
upcomingData: [],
pastData: [],
paymentData: [],
cmContestData: [],
myContestData: [],
isUserContestActive: false,
leaderboard: [],
leaderboardGloble: [],
bonus: 0,
scoketFlagOld: 0,
scoketContestChnage: 0,
};
this.state = {
currentRecord: {
id: "",
contestLogo: "",
contestName: "",
startTime: "",
endTime: "",
entryFee: "",
virtualFund: "",
},
urltemp: "",
};
const url = window.location.href;
}
componentDidMount() {
  var urlTempParam = "";
    if (
      localStorage.getItem("source") !== "" &&
      localStorage.getItem("theme") !== ""
    ) {
      const urltemp =
        "?source=" +
        localStorage.getItem("source") +
        "&theme=" +
        localStorage.getItem("theme");
      this.setState({ urltemp: urltemp });
    }
if (!this.props.auth.isAuthenticated) {
window.location = callBackBaseUrl + "?callBack=" + window.location.origin;
}
// console.log("profile-data==");
// .post(baseUrl + "api/profile-data", {},configToken)
axios
.post(baseUrl + "api/profile-data", {})
.then((res) => {
// console.log("profile-data=======",res.data.data);
this.setState({
bonus: res.data.data.bonus,
winningWalletBalance: res.data.data.winningamount,
cashWalletBalance: res.data.data.balance,
});
})
.catch();
this.setState({ scoketFlagOld: 0, scoketContestChnage: 0 });
this.getData();
this.getUserContestDetails()
}
getUserContestDetails = () => {
axios
.post(baseUrl + "api/community-config-data", {}, configToken)
.then((res) => {
var resp = res.data;
// console.log(
//   "resp.data[0].isContestEnable",
//   resp.data[0].isContestEnable
// );
if (resp.data[0].isContestEnable === "yes") {
this.setState({ isUserContestActive: true });
} else {
this.setState({ isUserContestActive: false });
}
});
};
getData = () => {
const socket = socketIOClient(baseUrl, { query: "jwtToken=" + jwtToken });
this.setState({ socketCollect: socket });
var collectThis = this;
socket.on("connect", () => {
collectThis.setState({ currentSocketId: socket.id });
socket.emit("socketFlag");
});
socket.emit("callContestDataCommunity");
socket.on("communityLivePairData", function (apiRespData) {
// console.log("livePairData==",apiRespData);
collectThis.setState({ livePairData: apiRespData.data });
});
socket.on("communityUpcomingContestData", function (apiRespData) {
collectThis.setState({ upcomingData: apiRespData.data });
});
socket.on("communityPastContestData", function (apiRespData) {
collectThis.setState({ pastData: apiRespData.data });
});
socket.on("communityPaymentData", function (apiRespData) {
collectThis.setState({ paymentData: apiRespData.data });
});
socket.on("communityContestData", function (apiRespData) {
collectThis.setState({ cmContestData: apiRespData.data });
});
socket.on("socketFlagData", function (apiRespData) {
if (collectThis.state.scoketFlagOld !== apiRespData.data.contest_flag) {
socket.emit("callContestDataCommunity");
socket.on("communityLivePairData", function (apiRespData) {
collectThis.setState({ livePairData: apiRespData.data });
});
socket.on("communityUpcomingContestData", function (apiRespData) {
collectThis.setState({ upcomingData: apiRespData.data });
});
socket.on("communityPastContestData", function (apiRespData) {
collectThis.setState({ pastData: apiRespData.data });
});
socket.on("communityPaymentData", function (apiRespData) {
collectThis.setState({ paymentData: apiRespData.data });
});
socket.on("communityMyContestData", function (apiRespData) {
collectThis.setState({ myContestData: apiRespData.data });
});
socket.on("communityContestData", function (apiRespData) {
collectThis.setState({ cmContestData: apiRespData.data });
});
socket.on("serverTime", function (apiRespData) {
collectThis.setState({ serverTime: apiRespData });
});
collectThis.setState({ scoketFlagOld: apiRespData.data.contest_flag });
} else {
collectThis.setState({ serverTime: apiRespData });
}
});
};
componentWillUnmount() {
//  clearInterval(this.intervalcontest);
var getSocket = this.state.socketCollect;
getSocket.emit("disconnectContestApi");
}
editRecord(record) {
this.setState({ currentRecord: record });
}
deleteRecord(record) {
axios
.post(baseUrl + "api/contest-delete", { _id: record._id })
.then((res) => {
if (res.status === 200) {
toast.success(res.data.message, toastStyles);
}
})
.catch();
this.upcomingRecord();
this.pastRecord();
}
pageChange(pageData) {
// console.log("OnPageChange", pageData);
}
render() {
return (
<>
<Navbar urlPath={true} symbol={false} />
<Sidebar />
<div className="in_page">
  <div className="container">
    <div className="row">
      <div className="col-md-7 col-12">
        <ul className="nav contatcs-tab" id="crypt-tab">
          <li role="presentation">
            <a
            className={
            this.props.match.params.type === "live" ||
            this.props.match.url === "/contest"
            ? "active show"
            : ""
            }
            href="#tabLive"
            data-toggle="tab"
            >
            Live Contest
            </a>
          </li>
          <li role="presentation">
            <a
            className={
            this.props.match.params.type === "upcoming"
            ? "active show"
            : ""
            }
            href="#tabUpcoming"
            data-toggle="tab"
            >
            Upcoming Contest
            </a>
          </li>
          {/* <li role="presentation">
            <a
            className={
            this.props.match.params.type === "past" ? "active show" : ""
            }
            href="#tabPast"
            data-toggle="tab"
            >
            Past Contest
            </a>
          </li> */}
          <li role="presentation">
            <a
            className={
            this.props.match.params.type === "my" ? "active show" : ""
            }
            href="#tabMy"
            data-toggle="tab"
            >
            My Contest
            </a>
          </li>
          {/* 
          <li role="presentation">
            <a
            className={
            this.props.match.params.type === "paymentHistory" ? "active show" : ""
            }
            href="#tabPy"
            data-toggle="tab"
            >
            Payment History
            </a>
          </li>
          */}
        </ul>
      </div>
      <div className="col-md-5 col-12 text-center">
        {this.state.isUserContestActive === true && ( <>
        <div className="d_hadding create-btn d-inline-flex  align-items-center">
		<span className="blink blink_aero"> <img src="/img/aero.png" alt="aero"/></span>
		 
		  
          <a href={this.state.urltemp !== ""
                      ? "/contest-create" + this.state.urltemp
                      : "/contest-create"} className="btn btn_man2 p_button">
          {/* <span className="ttt_box_icon ttt_box_icon1">
          <i className="las la-file-video"></i>
          </span> */}
          Create your own contest
          </a>
		   <a href="#" data-toggle="modal" data-target="#video" className="btn btn_man2  ml-3">
       How to create
          </a>
        </div>
		
		
        
        </>
        )}
      </div>
      {/* 
	 
      <div className="owl-carousel owl-theme">
        */}
        <div className="col-12">
          <div className="tab-content">
            <div
            className={
            this.props.match.params.type === "live" ||
            this.props.match.url === "/contest"
            ? "tab-pane contest-slider active show"
            : "tab-pane"
            }
            id="tabLive"
            >
            <LiveContest
              serverTime={this.state.serverTime}
              record={this.state.livePairData}
              bonus={this.state.bonus}
              winningWalletBalance={this.state.winningWalletBalance}
              cashWalletBalance={this.state.cashWalletBalance}
              contestCreated="User"
              />
          </div>
          <div
          className={
          this.props.match.params.type === "upcoming"
          ? "tab-pane active contest-slider show"
          : "tab-pane contest-slider"
          }
          id="tabUpcoming"
          >
          <UpcomingContest
            serverTime={this.state.serverTime}
            record={this.state.upcomingData}
            bonus={this.state.bonus}
            winningWalletBalance={this.state.winningWalletBalance}
            cashWalletBalance={this.state.cashWalletBalance} contestCreated="User"
            />
        </div>
        {/* <div
        className={
        this.props.match.params.type === "past"
        ? "tab-pane active contest-slider show"
        : "tab-pane contest-slider"
        }
        id="tabPast"
        >
        <PastContest
          record={this.state.pastData}
          bonus={this.state.bonus} contestCreated="User"
          />
      </div> */}
      <div 
      className={
      this.props.match.params.type === "my"
      ? "tab-pane active contest-slider show"
      : "tab-pane contest-slider"
      }
      id="tabMy"
      >
      <MyContest
        serverTime={this.state.serverTime}
        record={this.state.myContestData}
        bonus={this.state.bonus} contestCreated="User"
        />
    </div>
    {/* <div
    className={
    this.props.match.params.type === "paymentHistory"
    ? "tab-pane active contest-slider show"
    : "tab-pane contest-slider"
    }
    id="tabPy"
    >
    
    <PaymentHistory
      serverTime={this.state.serverTime}
      record={this.state.paymentData}
      bonus={this.state.bonus}
      />
   
  </div> */}
</div>
</div>
</div>
</div>
</div>


<div className="disclaimer-main">
  <div className="container">
    <div className="row">
      <div className='col-12'>
        <div className='disclaimer-outer'>
          <p><b>Disclaimer :</b> VTG is not responsible for prize distribution in community contest.</p>
        </div>
      </div>
    </div>
  </div>
</div>
<Footer />
<div className="modal fade" id="video">
  <div className="modal-dialog modal-lg">
    <div className="modal-content">
      <div className="modal-header">
        <h4 className="modal-title">Video</h4>
        <button type="button" className="close" data-dismiss="modal">&times;</button>
      </div>
      <div className="modal-body">
       <iframe src="https://www.youtube.com/embed/biO6z-pst34" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
      </div>

     
    </div>
  </div>
</div>
<Toaster position="bottom-right" reverseOrder={false} />
</>
);
}
}
CommunityContestPage.propTypes = {
auth: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
auth: state.auth,
contestdata: state.contestdata,
records: state.records,
});
export default connect(mapStateToProps)(CommunityContestPage);